import _implicitStylesheets from "./inputRadio.css";
import _implicitScopedStylesheets from "./inputRadio.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<label${"a0:for"} class="radioLabel${0}"${2}>${"t1"}</label>`;
const $fragment2 = parseFragment`<div class="showError${0}"${2}>${"t1"}</div>`;
const stc0 = {
  "inputRadio": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, gid: api_scoped_id, ti: api_tab_index, b: api_bind, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment} = $api;
  const {_m0} = $ctx;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.stateClassName),
    key: 0
  }, [api_element("input", {
    classMap: stc0,
    attrs: {
      "id": api_scoped_id("field"),
      "type": "radio",
      "name": $cmp.name,
      "tabindex": api_tab_index($cmp.tabIndex),
      "disabled": $cmp.disabled ? "" : null,
      "aria-label": $cmp.ariaLabel
    },
    props: {
      "value": $cmp.value,
      "checked": $cmp.checked
    },
    key: 1,
    on: {
      "change": _m0 || ($ctx._m0 = api_bind($cmp.handleCheckbox))
    }
  }), $cmp.label ? api_static_fragment($fragment1, 3, [api_static_part(0, {
    attrs: {
      "for": api_scoped_id("field")
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.label))]) : null]), $cmp._errorMessage ? api_static_fragment($fragment2, 5, [api_static_part(1, null, api_dynamic_text($cmp._errorMessage))]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-575vjjtu2ol";
tmpl.legacyStylesheetToken = "undefined-_inputRadio";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
